import {styled} from "@mui/material/styles"

interface ButtonContainerProps {
    top: number
    $height: number
}

export const ButtonContainer = styled("div")<ButtonContainerProps>`
    border-top: ${({theme}) => theme.colours.plp.facetDivider};
    margin-top: 1rem;
    padding-top: 1rem;
    cursor: pointer;

    ${({top, $height}) => {
        if (top > $height) {
            return `
                display: none;
            `
        }
    }}
`
